import React from "react";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";

import Button from "components/Button";
import Alert from "components/Alert";

// FormValues mirrors initialValues (all string) — yup validates them as
// strings, so the runtime shape stays string-typed.
interface FormValues {
  clientId: string;
  secret: string;
  companyCode: string;
}

interface Props {
  onSubmit: (values: FormValues) => void;
  isSubmitting?: boolean;
  error?: string;
  clientId?: string;
  companyCode?: string;
}

const validationSchema = yup.object().shape({
  clientId: yup
    .string()
    .min(5, "Client ID must be at least 5 characters")
    .required("Client ID is required"),
  secret: yup
    .string()
    .min(5, "Secret must be at least 5 characters")
    .required("Secret is required"),
  companyCode: yup
    .string()
    .min(1, "Company Short Name is required")
    .required("Company Short Name is required"),
});

const UkgConfigForm = ({
  onSubmit,
  isSubmitting,
  error,
  clientId,
  companyCode,
}: Props) => {
  return (
    <Formik
      initialValues={{
        clientId: clientId || "",
        secret: "",
        companyCode: companyCode || "",
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => onSubmit(values)}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form style={{ paddingLeft: 24 }} onSubmit={handleSubmit}>
          {error && <Alert type="error" msg={error} />}
          <Form.Group className="mb-3">
            <Form.Label>Company Short Name</Form.Label>
            <Form.Control
              type="text"
              name="companyCode"
              value={values.companyCode}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter your UKG Company Short Name"
              isInvalid={touched.companyCode && !!errors.companyCode}
              isValid={touched.companyCode && !errors.companyCode}
            />
            <Form.Control.Feedback type="invalid">
              {errors.companyCode}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Client ID</Form.Label>
            <Form.Control
              type="text"
              name="clientId"
              value={values.clientId}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter your UKG Client ID"
              isInvalid={touched.clientId && !!errors.clientId}
              isValid={touched.clientId && !errors.clientId}
            />
            <Form.Control.Feedback type="invalid">
              {errors.clientId}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Secret</Form.Label>
            <Form.Control
              type="password"
              name="secret"
              value={values.secret}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter your UKG Secret"
              isInvalid={touched.secret && !!errors.secret}
              isValid={touched.secret && !errors.secret}
            />
            <Form.Control.Feedback type="invalid">
              {errors.secret}
            </Form.Control.Feedback>
          </Form.Group>
          {/* @ts-expect-error Button `name` is required in props but optional at runtime (omitted here originally) */}
          <Button
            type="submit"
            btnLabel="Submit"
            loading={isSubmitting}
            withArrow
          />
        </Form>
      )}
    </Formik>
  );
};

export default UkgConfigForm;
